// src/lib/apiHandler.ts
import axios from "axios";
import { supabase } from "../hooks/supabase";

const apiUrl = import.meta.env.VITE_WARIO_URL;

const apiHandler = axios.create({
  baseURL: apiUrl,
  timeout: 10000,
});

apiHandler.interceptors.request.use(
  async (config) => {
    const session = await supabase.auth.getSession();
    const token = session.data.session?.access_token || '';
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiHandler.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.code === 'ERR_NAME_NOT_RESOLVED') {
      console.error('DNS resolution failed - check API domain configuration');
    } else if (error.response) {
      console.error('API error:', error.response.data);
    } else if (error.request) {
      console.error('Network error:', error.request);
    } else {
      console.error('Error:', error.message);
    }
    return Promise.reject(error);
  }
);

export default apiHandler;